import React from 'react'
import { FormattedMessage } from 'react-intl'
import { twMerge } from 'tailwind-merge'
import MouseGradientBlock from '../../../components/MouseGradientBlockAlt'

interface UniqueBlockProps {
  id: string
}

const UniqueBlock = ({ id }: UniqueBlockProps) => {
    return (
        <MouseGradientBlock className='md:min-h-[287px] aspect-auto border-b border-black/10'>
            <div className={twMerge('transition-all h-full py-7 md:py-10 md:pl-6 sm:pr-6 md:pr-10')}>
                <div className='md:max-w-[390px] h-full'>
                    <div className='flex flex-col h-full justify-between'>
                        <FormattedMessage id={`page.epp.unique.${id}.number`}>
                            {(value) => <span className='unique-card--number text-purple'>{value}</span>}
                        </FormattedMessage>
                        <FormattedMessage id={`page.epp.unique.${id}`}>
                            {(value) => (
                                <div
                                    className='pt-7 md:pt-10 unique-card--title'
                                    dangerouslySetInnerHTML={{ __html: value.toString() }}
                                ></div>
                            )}
                        </FormattedMessage>
                    </div>
                </div>
            </div>
        </MouseGradientBlock>
    )
}

export default UniqueBlock
